var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatterystatusred(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "battery status"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7493 0.92308H10.5121V0H7.28158V0.92308H6.10817C5.3446 0.92308 4.72363 1.54422 4.72363 2.30772V14.6154C4.72363 15.3788 5.34477 16 6.10817 16H11.7493C12.5131 16 13.1339 15.3788 13.1339 14.6154V2.30768C13.1339 1.54422 12.5131 0.92308 11.7493 0.92308ZM12.211 14.6155C12.211 14.8699 12.0039 15.077 11.7493 15.077H6.10817C5.85357 15.077 5.64648 14.8703 5.64648 14.6155V2.30768C5.64648 2.05332 5.85357 1.84613 6.10817 1.84613H11.7493C12.0039 1.84613 12.211 2.05329 12.211 2.30768V14.6155ZM11.7077 14.5307H6.14984V12.5056H11.7075L11.7077 14.5307Z",
    fill: "#C51F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatterystatusred);
export default __webpack_public_path__ + "static/media/batterystatusred.cacc08732b0f8173c1a6df43b384772e.svg";
export { ForwardRef as ReactComponent };